goog.provide("shadow.js.shim.module$src$svg$wpp$charts$graph_svg$default");
shadow.js.shim.module$src$svg$wpp$charts$graph_svg$default = shadow.js.shim.module$src$svg$wpp$charts$graph_svg.default;
